export default {"src":"/_next/static/media/loading.46c42de7.gif","height":202,"width":200,"blurWidth":0,"blurHeight":0};